import React from "react";
import { DataViewGrid } from "../../../shared/components/DataView";
import { InsuranceCoverage } from "@wingspanhq/wingspan-api-sdk";
import { mapInsuranceCoverageToDataView } from "../../Requirements/modules/SharedFile/configs/helpers/mapInsuranceCoverageToDataView";

export const InsuranceCoverageDataView: React.FC<{
  insuranceCoverage: InsuranceCoverage;
}> = ({ insuranceCoverage }) => {
  return (
    <DataViewGrid
      data={mapInsuranceCoverageToDataView(insuranceCoverage)}
      fullWidth={false}
      gridColumns={3}
    />
  );
};
